import { useEffect } from "react";
import { _LoanConfigProfile, _single } from "../../../../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../../../../theme/Component/BasicPage"
import { BasicTable, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";
import useModal, { MODAL_LG, MODAL_md } from "../../../../../theme/Component/hooks/useModal";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { Modal } from "../../../../../theme/Component/Modal";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { LoanConcept } from "./LoanConcept";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";

export const LoanConfigProfile = () => {

    const _config = useDataBean(_LoanConfigProfile);
    const { bean, setBean, lista, setLista, handleChange } = _config;

    const modalAdd = useModal("Configuración", MODAL_md);
    const modalDel = useModal("Eliminar", MODAL_md);
    const modalConcept = useModal("Conceptos", MODAL_LG);


    useEffect(() => {
        getLoanConfigProfileCatalog();
    }, [])

    const getLoanConfigProfileCatalog = () => {
        _config.instance.getLoanConfigProfileCatalog(null).then(
            (resp: any) => {
                setLista(resp)
            }
        )
    }

    const agregar = () => {
        setBean({});
        modalAdd.open();
    }
    const updateItem=()=>{
        _config.update().then(
            (resp:any)=>{
                getLoanConfigProfileCatalog();
                modalAdd.close();
            }
        )
    }
    const deleteItem =()=>{
        _config.deleteItemVoid(bean.IDLoanConfigProfile).then(
            (resp:any)=>{
                getLoanConfigProfileCatalog();
                modalDel.close();
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDLoanConfigProfile', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripcion', property: 'Description', visible: true },
        { title: 'Fecha Creación', property: 'Since', visible: true },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-file-add-line', visible: true, evento: () => { modalAdd.open() } },
            { titulo: 'Consultar/Configurar Conceptos', icono: 'ri-file-add-line', visible: true, evento: () => { modalConcept.open() } },
            { titulo: 'Eliimnar', icono: 'ri-file-add-line', visible: true, evento: () => { modalDel.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: agregar }
    ]

    return (
        <BasicPage titulo="Perfiles de Configuración de Conceptos de Crédito">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable head={head} body={lista} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} ></BasicTable>
                    <Modal modal={modalAdd.modal} updateModal={modalAdd.setModal} eventModal={updateItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" className="form-control" name="Name" value={bean.Name} onChange={handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={bean.Description} onChange={handleChange}></textarea>
                            </div>
                           
                            
                        </div>
                    </Modal>
                    <Modal modal={modalConcept.modal} updateModal={modalConcept.setModal} >
                        <LoanConcept idLoanConfigProfile={bean.IDLoanConfigProfile}/>
                    </Modal>
                    <ModalConfirm modal={modalDel.modal} updateModal={modalDel.setModal} eventModal={deleteItem}>
                        <strong>Eliminar Item?</strong>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}